// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bge_a bhb_vf bhb_a bhb_q bhb_k","AdSlotMail__mail--notLoaded":"bge_b bhb_eu bhb_bj bhb_vu","show-ad-not-loaded":"bge_c","AdSlotMail__cta":"bge_e"};